import React, { useState } from "react";
import styles from "./calendar-view.module.css";
import HolidayCalendar from "../holiday-calendar/holiday-calendar";
import { Typography } from "antd";
import moment from "moment";
import DateChanger from "../../../../components/date-changer/date-changer";

const CalendarView = ({ holidayList }) => {
  const [month, setMonth] = useState(moment().format("YYYY-MM"));

  const handleMonthChanger = (val) => {
    const newMonth = moment(month).add(val, "months");
    setMonth(newMonth.format("YYYY-MM"));
  };

  const currentDate = moment(month, "YYYY-MM").startOf("month").toDate();

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Typography className={styles.title}>Holiday Calendar</Typography>
        <DateChanger
          date={moment(month, "YYYY-MM").format("MMMM, YYYY")}
          onChange={handleMonthChanger}
        />
      </div>

      <div className={styles.main_view}>
        <HolidayCalendar
          eventData={holidayList}
          dateValue={currentDate}
          views={["month"]}
          height={600}
          defaultView="month"
          toolbar={false}
        />
      </div>
    </div>
  );
};

export default CalendarView;
